import React from "react";

// Main-portal side. Must run on https://songjukti.com
const USER_PORTAL_ORIGIN = "https://user.songjukti.com";
const USER_PORTAL_URL = `${USER_PORTAL_ORIGIN}/sso_login`;

// sessionKey = "<issuedAtMs>.<random>" — the receiver accepts it for 2 minutes only.
const makeSessionKey = () => {
  const rand = crypto.getRandomValues(new Uint32Array(2));
  return `${Date.now()}.${rand[0].toString(36)}${rand[1].toString(36)}`;
};

// Opens the user portal and hands the credentials over with postMessage.
// Nothing sensitive goes into the URL, and the message is delivered ONLY to
// the user-portal origin (the browser enforces targetOrigin).
export const openUserPortal = ({ sopnoid, mobilenumber, uReferId }) => {
  // No "noopener": the user portal needs window.opener to ask for the data.
  const popup = window.open(USER_PORTAL_URL, "_blank");
  if (!popup) return; // popup blocked

  const payload = { sopnoid, mobilenumber, uReferId, sessionKey: makeSessionKey() };

  const cleanup = () => {
    window.removeEventListener("message", onMessage);
    clearTimeout(timer);
  };

  const onMessage = (event) => {
    // Only the window we opened, from the exact user-portal origin.
    if (event.origin !== USER_PORTAL_ORIGIN || event.source !== popup) return;
    if (event.data?.type !== "sso-ready") return;
    popup.postMessage({ type: "sso-payload", payload }, USER_PORTAL_ORIGIN);
    cleanup(); // one delivery only
  };

  const timer = setTimeout(cleanup, 30_000);
  window.addEventListener("message", onMessage);
};

const OpenUserPortalButton = ({ user }) => (
  <button
    type="button"
    onClick={() =>
      openUserPortal({
        sopnoid: user.sopnoid,
        mobilenumber: user.umobile,
        uReferId: user.uReferId,
      })
    }
  >
    Open User Portal
  </button>
);

export default OpenUserPortalButton;